// Helpers de materiais usados em Serviços, Ocorrências e Maquinário
// Extraído de App.jsx — Fase B

function getMaterialUsageQty(material) {
  return Math.max(0, Number(material?.qtyUsed ?? material?.qty ?? material?.qtySeparated ?? 0) || 0);
}
function getRestockableMaterials(record) {
  return ((record?.materials) || []).filter(m => m?.stockId && getMaterialUsageQty(m) > 0);
}
function hasPendingMaterialRestock(record) {
  return getRestockableMaterials(record).length > 0 && !record?.materialRestockCompletedAt;
}
function hasCompletedMaterialRestock(record) {
  return !!record?.materialRestockCompletedAt || ((record?.materialRestockMovementIds || []).length > 0);
}

export {
  getMaterialUsageQty,
  getRestockableMaterials,
  hasPendingMaterialRestock,
  hasCompletedMaterialRestock,
};
